import { RemoteDataUtils } from '@assetmark/ui-kit/dist/utils/remote-data.utils';
import { RiskApi } from '../../apis/risk.api';
import { withRxJs } from '../../components/hoc/with-rx';
import { LeadQuestionAnswers } from '../../lib/das-api/model/leadQuestionAnswers';
import { TLeadRiskResponse } from '../../models/lead-risk-response';
import { RiskProfileComponent } from './risk-profile.component';

export const RiskProfileContainer = withRxJs(RiskProfileComponent)(() => {
	const riskTypeProfile$ = RiskApi.getRiskTypeProfile();
	const riskProfileData$ = RiskApi.getRiskProfileData();
	
	return {
		defaultProps: {
			riskTypeProfile: RemoteDataUtils.initial,
			riskProfileData: RemoteDataUtils.initial,
			riskQuestions: [],
			leadRisk: {} as TLeadRiskResponse,
			loadAllQusDataData: (leadId: string, QusId: number, AgId: string) => {
				RiskApi.getAllQuesData(leadId, QusId, AgId);
			},
			onSaveRiskQuestion: (leadId: string, body: Array<LeadQuestionAnswers>, agentId: string, currentRoute: string) => {
				RiskApi.saveSelectedQuestionAnswer(leadId, body, agentId, currentRoute); 
			}
		},
		props: {
			riskTypeProfile: riskTypeProfile$,
			riskProfileData: riskProfileData$,
			riskQuestions: RiskApi.getRiskQuestions$(),
			leadRisk: RiskApi.getLeadRiskProfile$()
		},
	};
});
